"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Header;

var _Grid2 = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _icons = _interopRequireDefault(require("../icons"));

var _Menu = _interopRequireDefault(require("./Menu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

Header.propTypes = {
  column: _propTypes["default"].object
};

function Header(_ref) {
  var column = _ref.column;
  var type = column.type,
      name = column.name,
      onSave = column.onSave,
      isEmbed = column.isEmbed,
      hideMenu = column.hideMenu;
  return /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    container: true,
    alignItems: "center",
    justifyContent: "space-between",
    wrap: "nowrap"
  }, /*#__PURE__*/_react["default"].createElement(_Grid2["default"], {
    container: true,
    alignItems: "center",
    wrap: "nowrap"
  }, _icons["default"][type], /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    ml: 1
  }), name), hideMenu ? null : isEmbed && /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    column: column,
    onSave: onSave
  }));
}